import { BackOffice } from 'package-types';

export class OfficesState {
  list: BackOffice.SiteOffice[] = [];
}
